import * as React from 'react';

import {Button} from '../button/button';
import {Popover} from '../popover/popover';

import {SingleAttachment} from './single-attachment';

import styles from './attachment-count.module.css';

type Props = {
    attachments: {
        length: number;
        models: any[];
    };
};
type State = {
    isExpanded: boolean;
};

export class AttachmentCount extends React.Component<Props, State> {
    attachmentCount: HTMLElement | null | undefined;

    constructor(props: Props) {
        super(props);
        this.state = {
            isExpanded: false,
        };
    }

    static getDerivedStateFromProps(props: Props, state: State) {
        // Prevent keeping isExpanded when all attachments are removed
        if (state.isExpanded && props.attachments.length === 0) {
            return {
                isExpanded: false,
            };
        }
    }

    render() {
        if (this.props.attachments.length === 0) {
            return null;
        }

        // Show the name directly, unless the popover is expanded, in which
        // case another attachment was probably removed, and we don't want that
        // to cause the popover to close.
        if (this.props.attachments.length === 1 && !this.state.isExpanded) {
            return (
                <div className={styles['attachment-count']}>
                    <SingleAttachment
                        fileName={this.props.attachments.models[0].get('filename')}
                        onRemove={() => this.props.attachments.models[0].destroy({wait: true})}
                    />
                </div>
            );
        }

        return (
            <div className={styles['attachment-count']}>
                <Button
                    // @ts-expect-error
                    getButtonRef={(node) => {
                        this.attachmentCount = node;
                    }}
                    variant='text-primary'
                    onClick={this.toggleExpand}
                >
                    {`${this.props.attachments.length} attached files`}
                </Button>
                {this.state.isExpanded ? (
                    <Popover
                        anchor={this.attachmentCount}
                        location='top'
                        onBlur={this.toggleExpand}
                    >
                        <ul className={styles['file-list']}>
                            {this.props.attachments.models.map((file) => (
                                <SingleAttachment
                                    fileName={file.get('filename')}
                                    onRemove={() => file.destroy({wait: true})}
                                    key={file.id || file.cid}
                                />
                            ))}
                        </ul>
                    </Popover>
                ) : null}
            </div>
        );
    }

    toggleExpand = () => {
        this.setState((prevState) => {
            return {
                isExpanded: !prevState.isExpanded,
            };
        });
    };
}
